import { Component, OnInit } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { ThemeService } from '../../services/theme.service';
import { ALL_THEMES } from '../../config/themes.config';

@Component({
  selector: 'app-theme-package-selector',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './theme-package-selector.component.html',
  styleUrls: ['./theme-package-selector.component.scss']
})
export class ThemePackageSelectorComponent implements OnInit {
  currentThemePackage: string = 'default';
  availableThemePackages = ALL_THEMES;

  constructor(private themeService: ThemeService) {}

  ngOnInit(): void {
    this.currentThemePackage = this.themeService.getCurrentThemePackage();

    this.themeService.currentThemePackage$.subscribe((pkg) => {
      this.currentThemePackage = pkg;
    });
  }

  changeThemePackage(packageId: string): void {
    this.themeService.setThemePackage(packageId);
  }

  getThemePackageName(packageId: string): string {
    const theme = this.availableThemePackages.find(t => t.id === packageId);
    return theme?.name || packageId;
  }
}
